import { AUTHENTICATION_CHANGE_PASSWORD_TYPE } from '../../constants/action_types';
export function changePassword(password) {
  return {
    type: AUTHENTICATION_CHANGE_PASSWORD_TYPE,
    password: password
  };
}